import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Link from 'next/link'
import { CodeSlash } from "react-bootstrap-icons";
import tutorialStyles from '../../styles/Tutorial.module.css'


export default function TutorialItem(props) {
    return (
            <Link href={props.tutorial.tutorial_slug} passHref>
                <a className="text-deco">
                    <Card className="card-hover h-100 shadow-sm">
                        <Card.Body>
                            <Row>
                                <Col lg={2} md={2} sm={12} className="my-auto text-center p-3">
                                    <CodeSlash className={tutorialStyles.tutorial_icon} />
                                </Col>
                                <Col lg={10} md={10} sm={12} className="my-auto">
                                    <h3 className="page-title">{props.tutorial.tutorial}</h3>
                                    <p className="page-subtext">{props.tutorial.tutorial_summary}</p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </a>
            </Link>
    )
}